import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "./BetModal.css";

const BetModal = ({ show, handleClose, selected }) => {
  const [odd, setOdd] = useState(0);
  const [stake, setStake] = useState(0);

  useEffect(() => {
    if (selected) {
      setOdd(Number(selected.odd));
      setStake(0);
    }
  }, [selected]);

  return (
    <Modal show={show} onHide={handleClose} centered>
      <div
        className={`modal-container p-3 ${
          selected?.type === "lay" ? "lay-mode" : "back-mode"
        }`}
      >
        {/* Top Section Buttons */}
        <div className="d-flex justify-content-between align-items-center gap-2 flex-wrap">
          {/* Cancel */}
          <button className="cancel-btn" onClick={handleClose}>
            Cancel
          </button>

          {/* Odd Counter */}
          <div className="bet-box">
            <button
              className="minus"
              onClick={() => odd > 0 && setOdd(odd - 0.01)}
            >
              -
            </button>
            <span className="value">{odd.toFixed(2)}</span>
            <button className="plus" onClick={() => setOdd(odd + 0.01)}>
              +
            </button>
          </div>

          {/* Stake Box */}
          <div className="bet-box">
            <button
              className="minus"
              onClick={() => stake > 0 && setStake(stake - 50)}
            >
              -
            </button>
            <span className="value">{stake}</span>
            <button className="plus" onClick={() => setStake(stake + 50)}>
              +
            </button>
          </div>

          {/* Place Bet */}
          <button
            className="place-btn"
            onClick={() => alert(`Bet Placed:\nOdd: ${odd}\nStake: ${stake}`)}
          >
            Place Bet
          </button>
        </div>

        {/* Amount Selection */}
        <div className="amount-options d-flex flex-wrap mt-3 gap-2 justify-content-center">
          {[100, 200, 500, 5000, 10000, 25000, 50000, 100000].map((v) => (
            <button
              key={v}
              className="amount-btn"
              onClick={() => setStake(stake + v)}
            >
              {v}
            </button>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default BetModal;
